export default {
  iam: {
    createOrganisation: 'Create Organisation',
    viewOrganisation: 'View Organisation',
    viewOrganisationUsers: 'View Organisation Users',
    editOrganisation: 'Edit Organisation',
    manageOrganisationUsers: 'Manage Organisation Users',
    listOrganisations: 'List Organisations',
  },
  projects: {
    createProject: 'Create Project',
    listProjects: 'List Projects',
    viewProject: 'View Project',
    deleteArchiveProject: 'Delete/Archive Project',
    manageProjectUsers: 'Manage Project Users',
    editProject: 'Edit Project',
    viewProjectBudgetSummaries: 'View Project Budget Summaries',
    manageProjects: 'Manage Projects',
  },
  sites: {
    createSite: 'Create Site',
    listSites: 'List Sites',
    viewSite: 'View Site',
    editSite: 'Edit Site',
    viewProjectBudgetSummary: 'View Project Budget Summary',
    manageSiteUsers: 'Manage Site Users',
    manageSites: 'Manage Sites',
  },
  vendorManagement: {
    createCustomVendor: 'Create Custom Vendor',
    createBoqVendor: 'Create BOQ Vendor',
    listOrgVendors: 'List Org Vendors',
    listBoqVendors: 'List BOQ Vendors',
    viewOrgVendor: 'View Org Vendor',
    viewBoqVendor: 'View BOQ Vendor',
    editOrgVendor: 'Edit Org Vendor',
    editBoqVendor: 'Edit BOQ Vendor',
    deleteOrgVendor: 'Delete Org Vendor',
    deleteBoqVendor: 'Delete BOQ Vendor',
    syncVendors: 'Sync Vendors',
    createOrgItem: 'Create Org Item',
    createBoqItem: 'Create BOQ Item',
    listOrgItems: 'List Org Items',
    listBoqItems: 'List BOQ Items',
    viewOrgItem: 'View Org Item',
    viewBoqItem: 'View BOQ Item',
    editOrgItem: 'Edit Org Item',
    editBoqItem: 'Edit BOQ Item',
    deleteOrgItem: 'Delete Org Item',
    deleteBoqItem: 'Delete BOQ Item',
    bulkUploadOrgItems: 'Bulk Upload Org Items',
    bulkUploadBoqItems: 'Bulk Upload BOQ Items',
    manageOrgVendors: 'Manage Org Vendors',
    manageBoqVendors: 'Manage BOQ Vendors',
    manageOrgItems: 'Manage Org Items',
    manageBoqItems: 'Manage BOQ Items',
  },
  boq: {
    createBoq: 'Create BOQ',
    deleteBoq: 'Delete BOQ',
    viewCostBoq: 'View Cost BOQ',
    viewSellingBoq: 'View Selling BOQ',
    exportBoq: 'Export BOQ',
    submitBoqForApproval: 'Submit BOQ for Approval',
    approveBoq: 'Approve BOQ',
    rejectBoq: 'Reject BOQ',
    viewBoqTemplates: 'View BOQ Templates',
    createBoqTemplate: 'Create BOQ Template',
    deleteBoqTemplate: 'Delete BOQ Template',
    makeBoqTemplatePublic: 'Make BOQ Template Public',
    addBoqSectionItemGroup: 'Add BOQ Section/Item/Group',
    editBoqSectionItemGroup: 'Edit BOQ Section/Item/Group',
    deleteBoqSectionItemGroup: 'Delete BOQ Section/Item/Group',
    addBoqVariation: 'Add BOQ Variation',
    approveBoqVariation: 'Approve BOQ Variation',
    rejectBoqVariation: 'Reject BOQ Variation',
    listClientVariations: 'List Client Variations',
    viewClientVariations: 'View Client Variations',
    createClientVariation: 'Create Client Variation',
    editClientVariation: 'Edit Client Variation',
    cancelClientVariation: 'Cancel Client Variation',
    approveClientVariation: 'Approve Client Variation',
    denyClientVariation: 'Deny Client Variation',
    logClientVariationPayment: 'Log Client Variation Payment',
    viewProvisionalBudgets: 'View Provisional Budgets',
    createProvisionalBudget: 'Create Provisional Budget',
    approveProvisionalBudgetRequest: 'Approve Provisional Budget Create',
    declineProvisionalBudgetRequest: 'Decline Provisional Budget Create',
    approveProvisionalBudgetAllocation: 'Approve Provisional Budget Allocation',
    declineProvisionalBudgetAllocation: 'Decline Provisional Budget Allocation',
    manageBoq: 'Manage BOQ',
    editBoq: 'Edit BOQ',
    manageBoqSectionsItemsGroups: 'Manage BOQ Sections/Items/Groups',
    manageBoqVariations: 'Manage BOQ Variations',
  },
  orders: {
    addItemToCart: 'Add item to cart',
    viewCart: 'View Cart',
    editCart: 'Edit Cart',
    editCartItems: 'Edit Cart items',
    removeCartItems: 'Remove Cart Items',
    clearCart: 'Clear Cart',
    createOrder: 'Create Order',
    approveOrderVariations: 'Approve Order Variations',
    rejectOrderVariations: 'Reject Order Variations',
    listOrders: 'List Orders',
    viewOrder: 'View Order',
    exportOrder: 'Export Order',
    shareOrder: 'Share Order',
    uploadOrderDocumentation: 'Upload Order Documentation',
    removeOrderDocumentation: 'Remove Order Documentation',
    cancelOrder: 'Cancel Order',
    approveOrder: 'Approve Order',
    rejectOrder: 'Reject Order',
    logOrderDelivery: 'Log Order Delivery',
    listBulkOrders: 'List Bulk Orders',
    viewBulkOrder: 'View Bulk Order',
    createBulkOrder: 'Create Bulk Order',
    approveBulkOrder: 'Approve Bulk Order',
    declineBulkOrder: 'Decline Bulk Order',
    cancelBulkOrder: 'Cancel Bulk Order',
    logBulkOrderDelivery: 'Log Bulk Order Delivery',
    completeBulkOrder: 'Complete Bulk Order',
    shareBulkOrder: 'Share Bulk Order',
    markBulkOrderVendorNotified: 'Mark Bulk Order Vendor Notified',
    uploadBulkOrderDocument: 'Upload Bulk Order Document',
    deleteBulkOrderDocument: 'Delete Bulk Order Document',
    manageCart: 'Manage Cart',
    manageOrders: 'Manage Orders',
    manageOrderVariations: 'Manage Order Variations',
  },
  paymentsPrsAps: {
    listPaymentRequests: 'List Payment Requests',
    viewPaymentRequest: 'View Payment Request',
    approvePaymentRequest: 'Approve Payment Request',
    declineBulkPaymentRequest: 'Decline Bulk Payment Request (Before Verification)',
    verifyBulkPaymentRequest: 'Verify Bulk Payment Request',
    approveBulkPaymentRequest: 'Approve Bulk Payment Request',
    pushBackBulkPaymentRequest: 'Push Back Bulk Payment Request',
    verifyPaymentRequest: 'Verify Payment Request',
    updatePaymentRequest: 'Update Payment Request',
    pushBackPaymentRequest: 'Push Back Payment Request',
    viewPaymentRequestsTotals: 'View Payment Requests Totals',
    listAccountsPayable: 'List Accounts Payable',
    viewAccountsPayableTotals: 'View Accounts Payable Totals',
    viewApLog: 'View AP Log',
    viewApOrders: 'View AP Orders',
    viewApClaims: 'View AP Claims',
    viewApPrs: 'View AP PRs',
    viewApStatements: 'View AP Statements',
    generateApStatement: 'Generate AP Statement',
    shareApStatement: 'Share AP Statement',
    deleteApStatement: 'Delete AP Statement',
    viewApPaymentHistory: 'View AP Payment History',
    listPayments: 'List Payments',
    createLogPayment: 'Create/Log Payment',
    viewProofOfPayment: 'View Proof of Payment',
    viewPaymentsSurface: 'View Payments Surface',
    uploadPrDocumentation: 'Upload PR Documentation',
    removePrDocumentation: 'Remove PR Documentation',
    createAdhocPayment: 'Create Adhoc Payment',
    manageAccountsPayable: 'Manage Accounts Payable',
  },
  compliance: {
    viewSiteCompliance: 'View Site Compliance',
    viewTemplates: 'View Templates',
    uploadDocuments: 'Upload Documents',
    removeDocuments: 'Remove Documents',
    uploadTemplate: 'Upload Template',
    deleteTemplate: 'Delete Template',
    changeSiteDates: 'Change Site Dates',
    downloadDocuments: 'Download Documents',
  },
  returns: {
    createAReturn: 'Create a return',
    approveAReturn: 'Approve a Return',
    rejectAReturn: 'Reject a Return',
    listReturns: 'List returns',
    viewAReturn: 'View a return',
    cancelAReturn: 'Cancel a return',
    listCreditsAndRefunds: 'List Credits & Refunds',
    viewACredit: 'View a Credit',
    viewARefund: 'View a Refund',
    cancelACredit: 'Cancel a Credit',
    cancelARefund: 'Cancel a Refund',
    completeACredit: 'Complete a Credit',
    completeARefund: 'Complete a Refund',
    editAReturn: 'Edit a Return',
    listRefunds: 'List Refunds',
  },
  dashboards: {
    viewOrgDashboard: 'View Org Dashboard',
    changeFinancialYear: 'Change Financial Year',
    viewClientDashboard: 'View Client Dashboard',
  },
  cashflow: {
    viewProjectCashflow: 'View Project Cashflow',
    updateOverheads: 'Update Overheads',
    exportCashflow: 'Export Cashflow',
    viewSiteCashflow: 'View Site Cashflow',
    exportProjectCashflow: 'Export Project Cashflow',
    updateProjectOverheads: 'Update Project Overheads',
  },
  bankDraws: {
    viewBankDraws: 'View Bank Draws',
    updateDrawAmounts: 'Update Draw Amounts',
    updateDrawSchedule: 'Update Draw Schedule',
    viewClaimSheet: 'View Claim Sheet',
    generateClaimSheet: 'Generate Claim Sheet',
    listBankDraws: 'List Bank Draws',
  },
  navigation: {
    navDashboard: 'Nav: Dashboard',
    navProjects: 'Nav: Projects',
    navOrders: 'Nav: Orders',
    navClaims: 'Nav: Claims',
    navAccounts: 'Nav: Accounts',
    navVendors: 'Nav: Vendors',
    navClientVariations: 'Nav: Client Variations',
  },
};
